// extracted by mini-css-extract-plugin
export default {"section_container":"styles_section_container__TXi8F","iconBox":"styles_iconBox__x5+vD","prev":"styles_prev__HunjX","next":"styles_next__2Uw-o","imgBox":"styles_imgBox__sb-w-"};